<ng-container
  kendoTooltip
  class="tooltip"
  [tooltipWidth]="400"
  filter="mat-card"
>
  <mat-card
    class="mat-elevation-z4"
    [ngClass]="{
      'companyCoverage': companyTacticTechniqueCoverage,
      'coverage': cyborgTacticTechniqueCoverage,
      'noCoverage': !cyborgTacticTechniqueCoverage
    }"
    [title]="toolTipString"
  >
    @if (count) {
    <hyperkit-typography
      [matMenuTriggerFor]="menu"
      display="inline"
      variant="body"
      color="secondary"
      size="sm"
      align="left"
      color="primary"
    >
      {{ child.name.replace('/', ' ') }}<br />({{ count }})</hyperkit-typography
    >
    } @else {
    <hyperkit-typography
      [matMenuTriggerFor]="menu"
      display="inline"
      variant="body"
      color="secondary"
      size="sm"
      align="left"
      color="primary"
    >
      {{ child.name.replace('/', ' ') }}</hyperkit-typography
    >
    }
  </mat-card>

  <mat-menu #menu="matMenu">
    <!-- <button mat-menu-item (click)="onFilter(child.name)">
        Apply as Filter
      </button> -->
    <div mat-menu-item (click)="onFilter(child.name)">
      <hyperkit-dropdown-menu-item
        label="Apply as filter"
      ></hyperkit-dropdown-menu-item>
    </div>

    @if (sub_techniques_array.length > 0) {
    <div mat-menu-item [matMenuTriggerFor]="subMenu">
      <hyperkit-dropdown-menu-item
        label="Sub-techniques"
      ></hyperkit-dropdown-menu-item>
    </div>
    }
  </mat-menu>

  <mat-menu #subMenu="matMenu">
    @for (sub of sub_techniques_array; track trackByFn($index, sub)) {
    <div mat-menu-item (click)="onFilter(sub.key)">
      <hyperkit-dropdown-menu-item
        label=" {{ sub.key }} ({{ sub.doc_count }})"
      ></hyperkit-dropdown-menu-item>
    </div>
    }
  </mat-menu>
</ng-container>
